export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Final2_14.c963e776.jpg";